<template></template>

<script>
import Cookies from "js-cookie";
import Bus from "../modules/Bus";
import Back from "../modules/Back";

export default {
  name: "Gate",
  data: {},
  created() {
    console.log("gate created");
    Cookies.set("auth-token", this.$route.query.token, { expires: 365 });
    // console.log("gate refresh", Cookies.get("auth-token"));

    const page = this.$route.query.page || "author";
    this.$router.push("/" + page);
    document.location.reload();
  }
};
</script>
